module.exports = __webpack_public_path__ + "img/mission.9aae98d8.png";